import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
// ─── Mock Data ────────────────────────────────────────────────────────────────

const DRIVER = {
  name: "Marcus Reed", initials: "MR", rating: 4.9,
  vehicle: "Kenworth T680", certCount: 12, plate: "TX-8821-P",
};

// ── Brand tokens — matches TrainingHub.jsx / email templates ─────────────
const NAVY   = "#0d1f3c";
const NAVY2  = "#1a3358";
const GOLD   = "#c9971c";
const GOLDL  = "#fbbf24";
const GREEN  = "#059669";
const BLUE   = "#1e56a8";
const PURPLE = "#7c3aed";
const RED    = "#dc2626";

const STATS = [
  { label: "Total Earnings",   value: "$42,500", sub: "↑ 8% this month",  up: true,  icon: "💰", color: "emerald" },
  { label: "Completed Loads",  value: "34",       sub: "↑ 3 this week",   up: true,  icon: "✅", color: "blue"    },
  { label: "Total Miles",      value: "12,450",   sub: "Since Jan 2025",  up: null,  icon: "🛣️", color: "indigo"  },
  { label: "Driver Rating",    value: "4.9 ★",    sub: "Top 3% nationally",up: null, icon: "⭐", color: "amber"   },
];

const ACTIVE_JOBS = [
  { id:"PL-2041", route:"TX → CA", from:"Austin, TX", to:"Bakersfield, CA", type:"Wind Turbine Blade",  pay:"$1,850", status:"In Transit",  statusKey:"transit",  date:"06/11/2026", escorts:2, progress:68 },
  { id:"PL-2038", route:"AZ → NV", from:"Phoenix, AZ",to:"Las Vegas, NV",   type:"Bridge Beam",        pay:"$920",   status:"Delivered",   statusKey:"delivered",date:"06/05/2026", escorts:1, progress:100 },
  { id:"PL-2035", route:"CO → UT", from:"Denver, CO", to:"Salt Lake City, UT",type:"Heavy Equipment",  pay:"$750",   status:"Scheduled",   statusKey:"scheduled",date:"05/29/2026", escorts:3, progress:0  },
];

const ALL_JOBS = [
  { id:"PL-2041", route:"Austin TX → Bakersfield CA",    type:"Wind Turbine Blade",  date:"06/11/2026", pay:"$1,850", status:"In Transit",  statusKey:"transit"   },
  { id:"PL-2038", route:"Phoenix AZ → Las Vegas NV",      type:"Bridge Beam",        date:"06/05/2026", pay:"$920",   status:"Completed",   statusKey:"delivered" },
  { id:"PL-2035", route:"Denver CO → Salt Lake City UT",  type:"Heavy Equipment",    date:"05/29/2026", pay:"$750",   status:"Completed",   statusKey:"delivered" },
  { id:"PL-2031", route:"Dallas TX → Oklahoma City OK",   type:"Modular Building",   date:"05/14/2026", pay:"$640",   status:"Completed",   statusKey:"delivered" },
  { id:"PL-2028", route:"Fresno CA → Portland OR",        type:"Steel Girders",      date:"04/28/2026", pay:"$1,120", status:"Completed",   statusKey:"delivered" },
];

const CERTS = [
  { state:"Texas",      code:"TX", req:"Level 1 Escort",       status:"active",   expiry:"Dec 2026" },
  { state:"Arizona",    code:"AZ", req:"Law Enforcement Check", status:"expiring", expiry:"Jul 2026" },
  { state:"Nevada",     code:"NV", req:"Amber Light Permit",    status:"active",   expiry:"Mar 2027" },
  { state:"Colorado",   code:"CO", req:"Mountain Pass Cleared", status:"inactive", expiry:"Expired"  },
  { state:"California", code:"CA", req:"PPCA + CHP Escort",     status:"active",   expiry:"Sep 2026" },
  { state:"Utah",       code:"UT", req:"Oversize Permit",       status:"active",   expiry:"Jan 2027" },
];

const COMPANIES = [
  { name:"GreenBridge Energy", abbr:"GB", type:"Carrier", id:"CB-2024-TX-8821", jobs:5, rating:"4.9★", status:"Active Contract", statusKey:"active",   bg:"#d1fae5", color:"#065f46" },
  { name:"TXHeavy Co.",        abbr:"TX", type:"Broker",  id:"TX-2023-8812",    jobs:3, rating:"4.7★", status:"Past Client",     statusKey:"inactive",  bg:"#dbeafe", color:"#1e40af" },
  { name:"SunGrid Power",      abbr:"SG", type:"Carrier", id:"SG-2024-AZ-5531", jobs:1, rating:"4.8★", status:"Saved",           statusKey:"saved",    bg:"#fef3c7", color:"#92400e" },
];

const INVOICE_LINES = [
  ["Job ID",          "PL-2041"],
  ["Client",          "GreenBridge Energy"],
  ["Service Date",    "06/11/2026"],
  ["Route",           "Austin TX → Bakersfield CA"],
  ["Escort Service",  "$1,650"],
  ["Fuel Surcharge",  "$120"],
  ["Equipment Fee",   "$80"],
];

const SAVED_LOADS_INIT = [
  { id:"PL-2043", type:"Transformer Unit",    from:"Phoenix, AZ",  to:"Las Vegas, NV",   pay:"$2,400", date:"06/14/2026", escorts:3, status:"Urgent", statusKey:"urgent" },
  { id:"PL-2045", type:"Petroleum Equipment", from:"Houston, TX",   to:"Baton Rouge, LA", pay:"$1,200", date:"06/16/2026", escorts:2, status:"Open",   statusKey:"open"   },
];

const DUMMY_FORM = {
  loadId:"PL-2043", loadType:"Transformer Unit",
  origin:"Phoenix, AZ", destination:"Las Vegas, NV",
  pay:"2,400", payType:"Fixed Rate", escorts:3,
  notes:"Night travel permit required. Police escort through city limits.",
  meetingPoint:"Pilot Travel Center Exit 182", meetingTime:"05:30",
};

const CHAT_INIT = [
  { id:"c1", from:"d", text:"Marcus, confirm load pickup at Bakersfield terminal.", ts:"09:14" },
  { id:"c2", from:"r", text:"Confirmed. Load secured, permits in hand. Rolling out now.", ts:"09:17" },
  { id:"c3", from:"d", text:"Watch the Tehachapi grade — 6% down slope. Adjust speed.", ts:"09:19" },
  { id:"c4", from:"r", text:"Roger. ETA Phoenix still on track for 14:30.", ts:"10:02" },
  { id:"c5", from:"d", text:"Good. Check in at Barstow rest stop. Fuel log required.", ts:"10:05" },
];
const AUTO_REPLIES = [
  "Copy that, dispatch.", "10-4. On it.",
  "Received. Will update at checkpoint.",
  "Roger. Mile marker noted.", "All good on my end.",
];

const tnow = () =>
  new Date().toLocaleTimeString("en-US", { hour:"2-digit", minute:"2-digit", hour12:false });

// ─── NAV ──────────────────────────────────────────────────────────────────────

const NAV_ITEMS = [
  { key:"overview",        label:"Overview",       icon:"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
  { key:"jobs",            label:"My Jobs",        icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" },
  { key:"saved-loads",     label:"Saved Loads",    icon:"M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z", badge:2 },
  { key:"certifications",  label:"Certifications", icon:"M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" },
  { key:"invoice",         label:"Invoices",       icon:"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
  { key:"companies",       label:"Companies",      icon:"M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" },
  { key:"messages",        label:"Messages",       icon:"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z", badge:3 },
  { key:"settings",        label:"Settings",       icon:"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

function Icon({ d, size = "w-5 h-5", stroke = 1.8 }) {
  return (
    <svg className={`${size} flex-shrink-0`} fill="none" stroke="currentColor" strokeWidth={stroke} viewBox="0 0 24 24">
      {d.split(" M").map((seg, i) => (
        <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i === 0 ? seg : "M" + seg} />
      ))}
    </svg>
  );
}

const STATUS_MAP = {
  transit:   "bg-blue-100 text-blue-700",
  delivered: "bg-green-100 text-green-700",
  scheduled: "bg-amber-100 text-amber-700",
  active:    "bg-green-100 text-green-700",
  expiring:  "bg-amber-100 text-amber-700",
  inactive:  "bg-gray-100 text-gray-500",
  urgent:    "bg-red-100 text-red-700",
  open:      "bg-green-100 text-green-700",
  saved:     "bg-amber-100 text-amber-700",
  Completed: "bg-green-100 text-green-700",
};

function Pill({ label, statusKey }) {
  const cls = STATUS_MAP[statusKey] || "bg-gray-100 text-gray-500";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${cls}`}>
      {label}
    </span>
  );
}

// ─── Stat Card ────────────────────────────────────────────────────────────────

function StatCard({ label, value, sub, icon, up }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-xl bg-gray-50 border border-gray-100 flex items-center justify-center text-xl">
          {icon}
        </div>
        {up != null && (
          <span className={`text-xs font-semibold ${up ? "text-green-600" : "text-red-500"}`}>
            {sub}
          </span>
        )}
      </div>
      <p className="text-xs text-gray-400 font-medium uppercase tracking-wider mb-1">{label}</p>
      <p className="text-2xl font-bold text-gray-900">{value}</p>
      {up == null && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
    </div>
  );
}

// ─── Progress Bar ─────────────────────────────────────────────────────────────

function ProgressBar({ pct, color = "bg-blue-500" }) {
  return (
    <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
      <div className={`h-full ${color} rounded-full transition-all duration-500`} style={{ width: `${pct}%` }} />
    </div>
  );
}

// ─── Section Header ───────────────────────────────────────────────────────────

function SectionHeader({ title, action, onAction }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-bold text-gray-900">{title}</h2>
      {action && (
        <button onClick={onAction} className="text-xs text-blue-600 hover:text-blue-800 font-semibold transition-colors">
          {action}
        </button>
      )}
    </div>
  );
}

// ─── Job Card ─────────────────────────────────────────────────────────────────

function JobCard({ job, compact = false }) {
  return (
    <div className="bg-white border border-gray-100 rounded-xl p-4 hover:shadow-sm hover:border-gray-200 transition-all">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1.5">
            <span className="text-sm font-bold text-gray-900">{job.id}</span>
            <Pill label={job.status} statusKey={job.statusKey} />
          </div>
          {!compact && (
            <p className="text-sm font-semibold text-gray-700 mb-1">{job.type}</p>
          )}
          <p className="text-xs text-gray-400">
            {compact ? job.route : `📍 ${job.from} → ${job.to}`}
            {job.date && <> · {job.date}</>}
          </p>
          {job.progress != null && job.progress > 0 && job.progress < 100 && !compact && (
            <div className="mt-2.5">
              <ProgressBar pct={job.progress} color="bg-blue-500" />
              <p className="text-[10px] text-gray-400 mt-1">{job.progress}% complete</p>
            </div>
          )}
        </div>
        <div className="flex-shrink-0 text-right">
          <p className="text-base font-bold text-amber-600">{job.pay}</p>
          {job.escorts && (
            <p className="text-[10px] text-gray-400 mt-0.5">{job.escorts} escort{job.escorts > 1 ? "s" : ""}</p>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Chat Panel ───────────────────────────────────────────────────────────────

function ChatPanel() {
  const [msgs, setMsgs] = useState(CHAT_INIT);
  const [inp, setInp] = useState("");
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = () => {
    if (!inp.trim()) return;
    setMsgs(p => [...p, { id: `m${Date.now()}`, from: "r", text: inp.trim(), ts: tnow() }]);
    setInp("");
    setTimeout(() => {
      setMsgs(p => [...p, {
        id: `dr${Date.now()}`, from: "d",
        text: AUTO_REPLIES[Math.floor(Math.random() * AUTO_REPLIES.length)],
        ts: tnow(),
      }]);
    }, 800 + Math.random() * 600);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Dispatch header */}
      <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-gray-50 flex-shrink-0">
        <div className="w-9 h-9 rounded-full flex items-center justify-center font-bold text-white text-sm flex-shrink-0" style={{ background: "#1a2744" }}>
          DC
        </div>
        <div>
          <p className="text-sm font-semibold text-gray-800">Dispatch Center</p>
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />
            <span className="text-xs text-green-600">Online</span>
          </div>
        </div>
        <div className="ml-auto">
          <span className="text-[10px] bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full font-semibold">Load PLU-2025-00129</span>
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
        {msgs.map(m => (
          <div key={m.id} className={`flex ${m.from === "r" ? "justify-end" : "justify-start"}`}>
            <div className={`flex flex-col ${m.from === "r" ? "items-end" : "items-start"} max-w-[80%]`}>
              {m.from === "d" && (
                <span className="text-[9px] text-gray-400 mb-0.5 px-1">Dispatch</span>
              )}
              <div className={`px-3 py-2 rounded-2xl text-sm leading-relaxed ${
                m.from === "r"
                  ? "text-white rounded-br-sm"
                  : "bg-gray-100 text-gray-800 rounded-bl-sm"
              }`} style={m.from === "r" ? { background: "#1a2744" } : {}}>
                {m.text}
              </div>
              <span className="text-[9px] text-gray-300 mt-1 px-1">{m.ts}</span>
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>

      {/* Input */}
      <div className="px-3 py-3 border-t border-gray-100 flex-shrink-0">
        <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-gray-50">
          <span className="text-gray-400 text-lg">📎</span>
          <input
            value={inp} onChange={e => setInp(e.target.value)}
            onKeyDown={e => e.key === "Enter" && send()}
            placeholder="Message dispatch..."
            className="flex-1 bg-transparent text-sm text-gray-800 placeholder-gray-300 outline-none min-w-0"
          />
          <button
            onClick={send} disabled={!inp.trim()}
            className="text-white text-xs px-3 py-1.5 rounded-lg font-semibold transition-colors flex-shrink-0 disabled:opacity-40"
            style={{ background: "#1a2744" }}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Consent Modal ────────────────────────────────────────────────────────────

function ConsentModal({ form, onSign, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.6)" }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between px-5 py-4" style={{ background: "#1a2744" }}>
          <span className="font-bold text-sm text-white">Job Application & Consent</span>
          <button onClick={onClose} className="text-white/50 hover:text-white text-xl">✕</button>
        </div>
        <div className="p-5">
          <p className="text-base font-bold text-gray-900 mb-1">{form.loadType} — {form.loadId}</p>
          <p className="text-sm text-gray-500 mb-4">Driver: <strong className="text-gray-700">{DRIVER.name}</strong></p>
          <div className="bg-gray-50 rounded-xl p-4 text-sm text-gray-600 leading-relaxed mb-5 space-y-1.5 border border-gray-100">
            <p>📍 {form.origin} → {form.destination}</p>
            <p>💰 ${form.pay} ({form.payType})</p>
            <p>👥 {form.escorts} escort{form.escorts > 1 ? "s" : ""} required</p>
            <p>📝 {form.notes}</p>
            <p>🚩 Meeting: {form.meetingPoint} · {form.meetingTime}</p>
          </div>
          <div className="flex gap-3">
            <button onClick={onClose} className="flex-1 border border-gray-200 text-gray-700 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors">
              Cancel
            </button>
            <button
              onClick={onSign}
              className="flex-1 text-white py-2.5 rounded-xl text-sm font-bold transition-colors"
              style={{ background: "#1a2744" }}
            >
              ✍️ Sign & Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Page: Overview ───────────────────────────────────────────────────────────

function OverviewPage({ setTab }) {
  return (
    <div className="space-y-5">
      {/* Hero greeting */}
      <div className="rounded-2xl p-5 flex items-center justify-between gap-4" style={{ background: "#1a2744" }}>
        <div>
          <h2 className="text-white font-bold text-base">Good morning, Marcus! 👋</h2>
          <p className="text-blue-200 text-sm mt-1">You have 1 active load in transit today.</p>
          <div className="flex items-center gap-3 mt-3">
            <div className="flex items-center gap-1.5 bg-white/10 rounded-lg px-3 py-1.5">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span className="text-xs text-white font-medium">On Route</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/10 rounded-lg px-3 py-1.5">
              <span className="text-xs text-white font-medium">⭐ {DRIVER.rating} · PPCA Certified</span>
            </div>
          </div>
        </div>
        <div className="hidden sm:flex flex-col gap-2 flex-shrink-0">
          <button
            onClick={() => setTab("saved-loads")}
            className="text-white text-xs font-semibold px-4 py-2 rounded-xl border border-white/25 bg-white/15 hover:bg-white/25 transition-colors"
          >
            📋 Load Board
          </button>
          <button
            onClick={() => setTab("messages")}
            className="text-white text-xs font-semibold px-4 py-2 rounded-xl border border-white/25 bg-white/15 hover:bg-white/25 transition-colors"
          >
            💬 Messages
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {STATS.map(s => <StatCard key={s.label} {...s} />)}
      </div>

      {/* Two-col grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Active Jobs */}
        <div>
          <SectionHeader title="Active Jobs" action="View all →" onAction={() => setTab("jobs")} />
          <div className="space-y-3">
            {ACTIVE_JOBS.map(j => <JobCard key={j.id} job={j} />)}
          </div>
        </div>

        {/* Certifications preview */}
        <div>
          <SectionHeader title="Certifications" action="Manage →" onAction={() => setTab("certifications")} />
          <div className="space-y-2">
            {CERTS.slice(0, 4).map(c => (
              <div key={c.state} className="bg-white border border-gray-100 rounded-xl px-4 py-3 flex items-center justify-between hover:shadow-sm transition-shadow">
                <div>
                  <p className="text-sm font-semibold text-gray-900">{c.state}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{c.req}</p>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <Pill label={c.status.charAt(0).toUpperCase() + c.status.slice(1)} statusKey={c.status} />
                  <span className="text-[10px] text-gray-400">{c.expiry}</span>
                </div>
              </div>
            ))}
            <button
              onClick={() => setTab("certifications")}
              className="w-full border border-gray-200 text-gray-600 py-2.5 rounded-xl text-xs font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-1.5"
            >
              + Add State Certification
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Page: My Jobs ────────────────────────────────────────────────────────────

function JobsPage() {
  const [filter, setFilter] = useState("all");
  const filtered = filter === "all" ? ALL_JOBS
    : filter === "active" ? ALL_JOBS.filter(j => j.statusKey === "transit")
    : ALL_JOBS.filter(j => j.statusKey === "delivered");

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-base font-bold text-gray-900">My Jobs</h2>
          <p className="text-xs text-gray-400 mt-0.5">Current and past escort assignments</p>
        </div>
        <div className="flex gap-1.5">
          {[["all","All"],["active","Active"],["delivered","Completed"]].map(([k,l]) => (
            <button key={k} onClick={() => setFilter(k)} className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${filter===k?"text-white":"bg-gray-100 text-gray-500 hover:bg-gray-200"}`} style={filter===k?{background:"#1a2744"}:{}}>{l}</button>
          ))}
        </div>
      </div>
      <div className="space-y-3">
        {filtered.map(j => (
          <div key={j.id} className="bg-white border border-gray-100 rounded-xl p-4 hover:shadow-sm transition-all">
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="font-bold text-gray-900">{j.id}</span>
                  <Pill label={j.status} statusKey={j.statusKey} />
                </div>
                <p className="text-xs text-gray-500">{j.route} · {j.type}</p>
                <p className="text-xs text-gray-400 mt-0.5">📅 {j.date}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-lg font-bold text-amber-600">{j.pay}</p>
                <button className="text-[10px] text-blue-600 font-medium hover:underline mt-1 block">View invoice →</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Page: Saved Loads ────────────────────────────────────────────────────────

function SavedLoadsPage({ savedLoads, setSavedLoads, onApply }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-base font-bold text-gray-900">Saved Loads</h2>
          <p className="text-xs text-gray-400 mt-0.5">Bookmarked loads to review and apply later</p>
        </div>
        <button className="border border-gray-200 text-gray-600 text-xs font-semibold px-3 py-2 rounded-xl hover:bg-gray-50 transition-colors">
          Browse load board
        </button>
      </div>

      {savedLoads.length === 0 ? (
        <div className="text-center py-20 border-2 border-dashed border-gray-200 rounded-2xl">
          <div className="text-4xl mb-3">❤️</div>
          <p className="font-bold text-gray-700 mb-1">No saved loads</p>
          <p className="text-sm text-gray-400">Tap the ❤️ on any listing to save it here</p>
        </div>
      ) : (
        <div className="space-y-3">
          {savedLoads.map(l => (
            <div key={l.id} className="bg-white border border-gray-100 rounded-xl p-4 hover:shadow-sm transition-all">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="font-bold text-gray-900">{l.id}</span>
                    <Pill label={l.status} statusKey={l.statusKey} />
                  </div>
                  <p className="text-sm font-semibold text-gray-800 mb-1">{l.type}</p>
                  <div className="flex flex-wrap gap-3 text-xs text-gray-500">
                    <span>📍 {l.from} → {l.to}</span>
                    <span>📅 {l.date}</span>
                    <span>👥 {l.escorts} escort{l.escorts > 1 ? "s" : ""}</span>
                  </div>
                </div>
                <div className="flex-shrink-0 text-right">
                  <p className="text-xl font-bold text-amber-600 mb-3">{l.pay}</p>
                  <div className="flex gap-2 justify-end">
                    <button
                      onClick={() => setSavedLoads(s => s.filter(x => x.id !== l.id))}
                      className="bg-red-50 text-red-700 border border-red-100 text-xs font-semibold px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors"
                    >
                      🗑 Remove
                    </button>
                    <button
                      onClick={onApply}
                      className="text-white text-xs font-bold px-3 py-1.5 rounded-lg transition-colors"
                      style={{ background: "#1a2744" }}
                    >
                      ✍️ Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Page: Certifications ─────────────────────────────────────────────────────

function CertificationsPage() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-base font-bold text-gray-900">Certifications</h2>
          <p className="text-xs text-gray-400 mt-0.5">Your active escort certifications by state</p>
        </div>
        <button className="text-white text-xs font-bold px-3 py-2 rounded-xl" style={{ background: "#1a2744" }}>
          + Add Certification
        </button>
      </div>

      {/* Summary chips */}
      <div className="flex gap-2 flex-wrap">
        {[["Active",CERTS.filter(c=>c.status==="active").length,"bg-green-50 text-green-700 border-green-100"],["Expiring",CERTS.filter(c=>c.status==="expiring").length,"bg-amber-50 text-amber-700 border-amber-100"],["Expired",CERTS.filter(c=>c.status==="inactive").length,"bg-red-50 text-red-700 border-red-100"]].map(([l,n,cls])=>(
          <div key={l} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold ${cls}`}>
            {l} <span className="font-bold">{n}</span>
          </div>
        ))}
      </div>

      <div className="space-y-2">
        {CERTS.map(c => (
          <div key={c.state} className={`bg-white border rounded-xl px-4 py-3.5 flex items-center justify-between hover:shadow-sm transition-all ${c.status === "expiring" ? "border-amber-200" : c.status === "inactive" ? "border-red-100" : "border-gray-100"}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-xs flex-shrink-0"
                style={{ background: c.status === "active" ? "#d1fae5" : c.status === "expiring" ? "#fef3c7" : "#f3f4f6", color: c.status === "active" ? "#065f46" : c.status === "expiring" ? "#92400e" : "#6b7280" }}>
                {c.code}
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">{c.state}</p>
                <p className="text-xs text-gray-400">{c.req}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs text-gray-400 hidden sm:block">{c.expiry}</span>
              <Pill label={c.status.charAt(0).toUpperCase() + c.status.slice(1)} statusKey={c.status} />
              {c.status === "expiring" && (
                <button className="text-xs text-amber-700 font-semibold bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-lg hover:bg-amber-100 transition-colors">
                  Renew
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Page: Invoice ────────────────────────────────────────────────────────────

function InvoicePage() {
  return (
    <div className="space-y-4 max-w-xl">
      <div>
        <h2 className="text-base font-bold text-gray-900">Invoice Builder</h2>
        <p className="text-xs text-gray-400 mt-0.5">Generate and send invoices for completed jobs</p>
      </div>
      <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
        {/* Invoice header */}
        <div className="px-5 py-4 flex items-center justify-between border-b border-gray-100" style={{ background: "#1a2744" }}>
          <div>
            <p className="text-white font-bold text-sm">Invoice #INV-2041</p>
            <p className="text-blue-200 text-xs mt-0.5">GreenBridge Energy · 06/11/2026</p>
          </div>
          <div className="w-10 h-10 bg-white/15 rounded-xl flex items-center justify-center text-white font-bold text-sm">MR</div>
        </div>
        <div className="px-5 py-4">
          {INVOICE_LINES.map(([k, v]) => (
            <div key={k} className="flex justify-between items-center py-2.5 border-b border-gray-50 last:border-0">
              <span className="text-xs text-gray-500">{k}</span>
              <span className="text-xs font-semibold text-gray-800">{v}</span>
            </div>
          ))}
          <div className="flex justify-between items-center pt-4 mt-1">
            <span className="font-bold text-gray-900">Total</span>
            <span className="text-2xl font-black text-amber-600">$1,850.00</span>
          </div>
          <div className="flex gap-3 mt-5">
            <button className="flex-1 text-white py-2.5 rounded-xl text-sm font-bold transition-colors flex items-center justify-center gap-2" style={{ background: "#1a2744" }}>
              📤 Send Invoice
            </button>
            <button className="flex-1 bg-gray-50 border border-gray-200 text-gray-700 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center gap-2">
              ⬇ Download PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Page: Companies ─────────────────────────────────────────────────────────

function CompaniesPage({ setTab }) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-base font-bold text-gray-900">Companies</h2>
        <p className="text-xs text-gray-400 mt-0.5">Partners you've worked with or saved</p>
      </div>
      <div className="space-y-3">
        {COMPANIES.map(c => (
          <div key={c.name} className="bg-white border border-gray-100 rounded-xl p-4 hover:shadow-sm transition-all">
            <div className="flex items-center gap-4 flex-wrap">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center font-bold text-sm flex-shrink-0"
                style={{ background: c.bg, color: c.color }}>{c.abbr}</div>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-gray-900">{c.name}</p>
                <p className="text-xs text-gray-400 mt-0.5">{c.type} · {c.id} · {c.jobs} jobs · {c.rating}</p>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <Pill label={c.status} statusKey={c.statusKey} />
                <button
                  onClick={() => setTab("messages")}
                  className="text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors flex items-center gap-1"
                  style={{ background: "#1a2744" }}
                >
                  💬 Chat
                </button>
                <button className="border border-gray-200 text-gray-600 text-xs font-medium px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors">
                  View Loads
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Page: Messages ───────────────────────────────────────────────────────────

function MessagesPage() {
  return (
    <div className="h-full flex flex-col">
      <div className="mb-3">
        <h2 className="text-base font-bold text-gray-900">Messages</h2>
        <p className="text-xs text-gray-400 mt-0.5">Direct line to dispatch</p>
      </div>
      <div className="flex-1 bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm min-h-0" style={{ height: "calc(100% - 60px)" }}>
        <ChatPanel />
      </div>
    </div>
  );
}

// ─── Page: Settings ───────────────────────────────────────────────────────────

function SettingsPage() {
  return (
    <div className="space-y-4 max-w-xl">
      <div>
        <h2 className="text-base font-bold text-gray-900">Settings</h2>
        <p className="text-xs text-gray-400 mt-0.5">Manage your account and preferences</p>
      </div>
      {[
        { title:"Profile", sub:"Update your name, photo, and contact info", icon:"👤" },
        { title:"Vehicle Info", sub:"Kenworth T680 · TX-8821-P", icon:"🚛" },
        { title:"Notifications", sub:"Push, email, and SMS preferences", icon:"🔔" },
        { title:"Payment Info", sub:"Bank account and payout settings", icon:"💳" },
        { title:"Privacy & Security", sub:"Password, 2FA, and data settings", icon:"🔒" },
      ].map(s => (
        <div key={s.title} className="bg-white border border-gray-100 rounded-xl px-4 py-3.5 flex items-center gap-3 hover:shadow-sm cursor-pointer transition-all">
          <div className="w-10 h-10 bg-gray-50 rounded-xl flex items-center justify-center text-lg flex-shrink-0">{s.icon}</div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900">{s.title}</p>
            <p className="text-xs text-gray-400 mt-0.5">{s.sub}</p>
          </div>
          <svg className="w-4 h-4 text-gray-300 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
        </div>
      ))}
      <button className="w-full bg-red-50 border border-red-100 text-red-700 py-2.5 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors mt-4">
        Sign Out
      </button>
    </div>
  );
}

// ─── ROOT COMPONENT ───────────────────────────────────────────────────────────

export default function DriverDashboardPage({
  nav = (route) => console.log("Navigate:", route),
  user = { name: "Marcus Reed" },
}) {
  const [tab,         setTab]         = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showConsent, setShowConsent] = useState(false);
  const [savedLoads,  setSavedLoads]  = useState(SAVED_LOADS_INIT);
  const [mobileView,  setMobileView]  = useState("dashboard");

  const PAGE_TITLE = {
    overview:"Overview", jobs:"My Jobs", "saved-loads":"Saved Loads",
    certifications:"Certifications", invoice:"Invoices",
    companies:"Companies", messages:"Messages", settings:"Settings",
  };

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden" style={{ fontFamily:"Inter,system-ui,sans-serif" }}>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── SIDEBAR ── */}
      <aside
        className={`fixed lg:relative z-50 lg:z-auto top-0 left-0 h-full w-56 flex-shrink-0 flex flex-col transition-transform duration-300 ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        style={{ background: "#1a2744" }}
      >
        {/* Logo */}
        <div className="flex items-center gap-2.5 px-4 py-4 border-b border-white/10 flex-shrink-0">
         
          <div>
             <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", flexShrink: 0 }}>
                        <div style={{
                          width: 32, height: 32, borderRadius: 8, background: GOLD,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontWeight: 900, fontSize: 15, color: NAVY,
                        }}>P</div>
                        <span style={{ fontSize: 16, fontWeight: 800, whiteSpace: "nowrap" }}>
                          <span style={{ color: GOLD }}>PilotLinkUSA</span>{" "}
                          {/* <span style={{ fontSize: 10, fontWeight: 600, color: WHITE }}>USA</span> */}
                        </span>
                      </Link>
          </div>
          <button onClick={() => setSidebarOpen(false)} className="ml-auto lg:hidden text-white/50 hover:text-white">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Driver chip */}
        <div className="mx-3 mt-3 rounded-xl p-2.5 flex items-center gap-2.5 flex-shrink-0" style={{ background: "rgba(255,255,255,0.07)" }}>
          <div className="w-8 h-8 rounded-lg bg-blue-500 flex items-center justify-center font-bold text-white text-xs flex-shrink-0">
            {DRIVER.initials}
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold text-white truncate">{DRIVER.name}</p>
            <p className="text-[9px] text-white/40 truncate">⭐ {DRIVER.rating} · PPCA Certified</p>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-2 py-3 overflow-y-auto space-y-0.5">
          <p className="px-3 py-1 text-[9px] font-bold uppercase tracking-widest text-white/30">Main Menu</p>
          {NAV_ITEMS.map(({ key, label, icon, badge }) => (
            <button
              key={key}
              onClick={() => { setTab(key); setSidebarOpen(false); }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all ${tab === key ? "bg-blue-600 text-white" : "text-gray-300 hover:bg-white/10 hover:text-white"}`}
            >
              <Icon d={icon} size="w-4 h-4" />
              <span className="truncate">{label}</span>
              {badge && (
                <span className={`ml-auto text-[9px] font-bold px-1.5 py-0.5 rounded-full flex-shrink-0 ${tab === key ? "bg-white/20 text-white" : "bg-red-500 text-white"}`}>
                  {badge}
                </span>
              )}
            </button>
          ))}

          <div className="border-t border-white/10 my-2" />
          <p className="px-3 py-1 text-[9px] font-bold uppercase tracking-widest text-white/30">Account</p>
          <button
            onClick={() => nav("loadboard")}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-300 hover:bg-white/10 hover:text-white transition-all"
          >
            <span className="text-base">📋</span>
            <span>Load Board</span>
          </button>
          <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-red-300 hover:bg-red-500/10 transition-all">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
            Sign Out
          </button>
        </nav>

        {/* Today summary */}
        <div className="mx-3 mb-3 rounded-xl p-3 border border-white/10 flex-shrink-0" style={{ background: "rgba(255,255,255,0.05)" }}>
          <p className="text-[9px] font-bold text-white/30 uppercase tracking-widest mb-2">Today's Summary</p>
          {[["Earnings Today","$1,850"],["Miles Driven","312 mi"],["Loads Active","1"],["Alerts","0"]].map(([l,v])=>(
            <div key={l} className="flex justify-between items-center py-0.5">
              <span className="text-[10px] text-gray-400">{l}</span>
              <span className="text-[10px] font-bold text-white">{v}</span>
            </div>
          ))}
        </div>

        {/* Find Loads CTA */}
        <div className="px-3 pb-4 flex-shrink-0">
          <button
            onClick={() => nav("loadboard")}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-xl text-sm font-bold transition-colors flex items-center justify-center gap-2"
          >
            <span>📋</span> Find Loads
          </button>
        </div>
      </aside>

      {/* ── MAIN CONTENT ── */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">

        {/* ── TOPBAR ── */}
        <header className="h-14 bg-white border-b border-gray-200 flex items-center px-3 sm:px-5 gap-3 flex-shrink-0 z-30">
          <button onClick={() => setSidebarOpen(true)} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-lg lg:hidden">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/></svg>
          </button>

          <h1 className="text-lg font-bold text-gray-900">{PAGE_TITLE[tab] || "Dashboard"}</h1>

          {/* Search */}
          <div className="flex-1 max-w-sm mx-4 hidden sm:flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">
            <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
            <input placeholder="Search jobs, certs, companies..." className="flex-1 bg-transparent text-sm text-gray-600 placeholder-gray-300 outline-none min-w-0" />
          </div>

          <div className="ml-auto flex items-center gap-1 sm:gap-3">
            {/* Notifications */}
            <button className="relative w-9 h-9 hover:bg-gray-100 rounded-xl flex items-center justify-center text-gray-500">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
              <span className="absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center">2</span>
            </button>
            {/* Messages */}
            <button onClick={() => setTab("messages")} className="w-9 h-9 hover:bg-gray-100 rounded-xl items-center justify-center text-gray-500 hidden sm:flex">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
            </button>
            {/* Find Loads CTA */}
            <button
              onClick={() => nav("loadboard")}
              className="hidden sm:flex items-center gap-1.5 text-white text-xs font-bold px-3 py-2 rounded-xl"
              style={{ background: "#1a2744" }}
            >
              📋 Find Loads
            </button>
            {/* Avatar */}
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-sm">
                {DRIVER.initials}
              </div>
              <div className="hidden md:block">
                <p className="text-sm font-semibold text-gray-800 leading-tight">{DRIVER.name}</p>
                <div className="flex items-center gap-1">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"/>
                  <span className="text-xs text-green-600">On Route</span>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* ── CONTENT ── */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-5xl mx-auto px-3 sm:px-6 py-5">
            {tab === "overview"        && <OverviewPage setTab={setTab} />}
            {tab === "jobs"            && <JobsPage />}
            {tab === "saved-loads"     && <SavedLoadsPage savedLoads={savedLoads} setSavedLoads={setSavedLoads} onApply={() => setShowConsent(true)} />}
            {tab === "certifications"  && <CertificationsPage />}
            {tab === "invoice"         && <InvoicePage />}
            {tab === "companies"       && <CompaniesPage setTab={setTab} />}
            {tab === "messages"        && <div className="h-[calc(100vh-140px)]"><MessagesPage /></div>}
            {tab === "settings"        && <SettingsPage />}
          </div>
        </main>

        {/* ── MOBILE BOTTOM NAV ── */}
        <nav className="lg:hidden flex-shrink-0 bg-white border-t border-gray-200 flex" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
          {[
            { key:"overview",       label:"Home",   icon:"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
            { key:"jobs",           label:"Jobs",   icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" },
            { key:"certifications", label:"Certs",  icon:"M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" },
            { key:"messages",       label:"Chat",   icon:"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" },
            { key:"settings",       label:"More",   icon:"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" },
          ].map(item => (
            <button
              key={item.key}
              onClick={() => setTab(item.key)}
              className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${tab === item.key ? "text-blue-600" : "text-gray-400"}`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                {item.icon.split(" M").map((seg, i) => (
                  <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i === 0 ? seg : "M" + seg} />
                ))}
              </svg>
              <span className="text-[9px] font-medium">{item.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Consent Modal */}
      {showConsent && (
        <ConsentModal
          form={DUMMY_FORM}
          onSign={() => setShowConsent(false)}
          onClose={() => setShowConsent(false)}
        />
      )}
    </div>
  );
}
